function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10.6667 1.33333H7.88C7.6 0.56 6.86667 0 6 0C5.13333 0 4.4 0.56 4.12 1.33333H1.33333C0.6 1.33333 0 1.93333 0 2.66667V13.3333C0 14.0667 0.6 14.6667 1.33333 14.6667H10.6667C11.4 14.6667 12 14.0667 12 13.3333V2.66667C12 1.93333 11.4 1.33333 10.6667 1.33333ZM6 1.33333C6.36667 1.33333 6.66667 1.63333 6.66667 2C6.66667 2.36667 6.36667 2.66667 6 2.66667C5.63333 2.66667 5.33333 2.36667 5.33333 2C5.33333 1.63333 5.63333 1.33333 6 1.33333ZM10 13.3333H2C1.63333 13.3333 1.33333 13.0333 1.33333 12.6667V3.33333C1.33333 2.96667 1.63333 2.66667 2 2.66667H2.66667V3.33333C2.66667 4.06667 3.26667 4.66667 4 4.66667H8C8.73333 4.66667 9.33333 4.06667 9.33333 3.33333V2.66667H10C10.3667 2.66667 10.6667 2.96667 10.6667 3.33333V12.6667C10.6667 13.0333 10.3667 13.3333 10 13.3333Z",
  clipRule: "evenodd"
});

var SvgIcPaste = function SvgIcPaste(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcPaste, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_paste.c2aed923.svg";
export { ForwardRef as ReactComponent };